<form
  class="flex flex-col justify-between gap-4 md:px-10 xl:w-[1300px]"
  [formGroup]="activityFormService.activityForm"
>
  <section class="m-auto flex max-w-[500px] flex-1 flex-col md:gap-10">
    <div class="flex flex-col gap-4">
      <h2 class="text-center text-primary-900">
        {{ "prestation.activity.title" | transloco }}
      </h2>
      <p class="text-center text-paragraph-s-reg">
        {{ "prestation.activity.description" | transloco }}
      </p>
    </div>
    <div class="flex flex-col items-start">
      <label for="title" class="text-paragraph-xs-med text-greyscale-700">
        {{ "prestation.transportTitle.label" | transloco
        }}<span class="text-greyscale-500">
          ({{ "optional" | transloco }})</span
        >
      </label>
      <input
        pInputText
        id="title"
        formControlName="title"
        [fluid]="true"
        [placeholder]="'prestation.activityTitle.placeholder' | transloco"
      />
      <app-error [control]="activityFormService.activityForm.get('title')!" />
    </div>
  </section>
  <app-select-activity-type />
  @if (activityFormService.displayCustomEmissionFactors) {
    <app-select-custom-factor
    />
  }
  @if (activityFormService.displaySelectCalculationMode) {
    <app-select-calculation-mode />
  }

  @if (activityFormService.displayDistance) {
    <section class="flex flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
      <app-distance-form />
    </section>
  }
  @if (activityFormService.displayHours) {
    <section class="flex flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
      <app-duration-form />
    </section>
  }
  @if (activityFormService.displayDays) {
    <section class="flex flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
      <app-duration-days-form />
    </section>
  }
  @if (activityFormService.displayPassenger) {
    <section class="flex flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
      <app-passenger-form />
    </section>
  }
  <section class="flex flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
    <div class="flex flex-col gap-2">
      <h4 class="text-primary-900">
        {{ "prestation.scheduledDays.title" | transloco }}
      </h4>
      <p class="text-paragraph-xs-reg">
        {{ "prestation.scheduledDays.description" | transloco }}
      </p>
    </div>
    <app-scheduled-days-selector
      [formGroup]="activityFormService.activityForm"
    />
  </section>
</form>
<div class="flex flex-row items-end justify-end gap-4">
  <p-button
    [label]="'close' | transloco"
    (click)="close()"
    severity="secondary"
    [text]="true"
  />

  <p-button
    [label]="'save' | transloco"
    (click)="submit()"
    [loading]="loading"
    [disabled]="activityFormService.activityForm.invalid"
  />
</div>
